import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';

const ApiConnection = ({mail, pwd, Lancer, setLancer, setResponse}) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  
  useEffect(() => {
    if (Lancer) {
        fetchData();
    }
  });


   const fetchData = async () => {
     setLoading(true);
    // const apiUrl = 'https://prep.goodplanet.org/wp-json/jwt-auth/v1/token';

    const apiUrl = '/api/wpconnect';
    
    const data = {
        username: mail,
        password: pwd
    };

    try {
      const result = await axios.post(apiUrl, data);
       // Mettre à jour la réponse de l'API dans le composant parent
       //    setApiResponse(result.data);
       setLancer(false);
       setResponse(result);

       

    } catch (error) {
      console.error("Erreur lors de l'envoi de la requête :", error);
      setResponse(error);
      setLancer(false)
    } finally {
      setLoading(false);
      setLancer(false);
    }
  };
  return (null);
};

export default ApiConnection;
